import {IWorkshopRoom} from '@sv/interfaces';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-booth-chat',
  templateUrl: './booth-chat.component.html',
  styleUrls: ['./booth-chat.component.scss']
})
export class BoothChatComponent{
  @Input() room: IWorkshopRoom;

  constructor() { }


}
